import React, { useEffect, useState } from 'react';
import { Loader2, Merge } from 'lucide-react';
import { Button } from '../../../ui/button';
import { Input } from '../../../ui/input';
import { Label } from '../../../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../../../ui/dialog';
import { ColorImage } from '../ColorImage';
import { tierLabels } from '../../../../lib/fabricLabels';

export const MergeMaterialsDialog = ({ open, onOpenChange, materials, onMerge, saving, brandName }) => {
  const L = tierLabels(brandName);
  const [name, setName] = useState('');
  const totalColors = materials.reduce((n, m) => n + (m.colors?.length || 0), 0);

  useEffect(() => {
    if (open) setName(materials.map(m => m.name).join(' | '));
  }, [open, materials]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="merge-materials-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Merge className="w-4 h-4" /> Merge {materials.length} {L.tier3Plural}</DialogTitle>
          <DialogDescription>
            All {totalColors} colors will be moved into one {L.tier3.toLowerCase()}. Old names are kept as aliases so catalog resyncs land in the merged {L.tier3.toLowerCase()}.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="flex flex-wrap gap-1.5">
            {materials.map(m => (
              <span key={m.id} className="inline-flex items-center gap-1.5 rounded-full border border-neutral-200 bg-neutral-50 pl-1 pr-2.5 py-0.5 text-xs" data-testid={`merge-source-${m.id}`}>
                <span className="w-5 h-5 rounded-full overflow-hidden border border-neutral-200">
                  {m.image_url ? <ColorImage src={m.image_url} alt="" w={128} className="w-full h-full" /> : <span className="block w-full h-full bg-neutral-200" />}
                </span>
                {m.name} <span className="text-neutral-400">({m.colors?.length || 0})</span>
              </span>
            ))}
          </div>
          <div>
            <Label>New {L.tier3} name *</Label>
            <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g., Hongkong | Osaka" className="mt-1" data-testid="merge-target-name-input" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={() => onMerge(name.trim())} disabled={saving || !name.trim()} className="bg-amber-600 hover:bg-amber-700 gap-2" data-testid="merge-confirm-btn">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Merge className="w-4 h-4" />} Merge
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
